import React from 'react';
import { Box, Typography, CircularProgress, keyframes, Paper } from '@mui/material';

// Floating dots animation
const float = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
`;

// Pulse animation for the container
const pulse = keyframes`
  0%, 100% {
    transform: translateX(-50%) scale(1);
  }
  50% {
    transform: translateX(-50%) scale(1.02);
  }
`;

const DisconnectedOverlay = ({ isConnected }) => {
  if (isConnected) return null;

  // Theme colors matching the app
  const primaryColor = '#5757b0';
  const lightPurple = '#f0f0ff';

  return (    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        background: 'white',
        border: `2px solid ${primaryColor}`,
        padding: '12px 20px',
        borderRadius: 3,
        boxShadow: `0px 8px 24px rgba(87, 87, 176, 0.2), 0px 4px 12px rgba(87, 87, 176, 0.1)`,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        minWidth: '220px',
        justifyContent: 'center',
        animation: `${pulse} 2s ease-in-out infinite`,
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: `0px 12px 32px rgba(87, 87, 176, 0.25), 0px 6px 16px rgba(87, 87, 176, 0.15)`,
          transform: 'translateX(-50%) translateY(-2px)',
          animation: 'none',
        }
      }}
    >
      {/* Loading indicator */}
      <CircularProgress 
        size={18} 
        sx={{ 
          color: primaryColor,
          filter: `drop-shadow(0 0 4px rgba(87, 87, 176, 0.6))`,
        }} 
      />
      
      {/* Status text */}
      <Typography 
        variant="body2" 
        sx={{ 
          color: primaryColor,
          fontSize: '0.875rem',
          fontWeight: 600,
          letterSpacing: '0.02em',
        }}
      >
        Waiting for server...
      </Typography>

      {/* Floating dots indicator */}
      <Box sx={{ display: 'flex', gap: 0.4, ml: 0.5 }}>
        {[0, 1, 2].map((index) => (
          <Box
            key={index}
            sx={{
              width: 5,
              height: 5,
              borderRadius: '50%',
              backgroundColor: primaryColor,
              animation: `${float} 1.5s ease-in-out infinite`,
              animationDelay: `${index * 0.2}s`,
              opacity: 0.8,
              boxShadow: `0 0 4px rgba(87, 87, 176, 0.4)`,
            }}
          />
        ))}
      </Box>
    </Paper>
  );
};

export default DisconnectedOverlay;
